"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalVariantBalance = void 0;
const getTotalOrderInvoiced_1 = require("./getTotalOrderInvoiced");
const getTotalVariantValue_1 = require("./getTotalVariantValue");
const getTotalVariantBalance = (order, variant) => {
    if (!variant || !order)
        return 0;
    return (0, getTotalVariantValue_1.getTotalVariantValue)(variant) - (0, getTotalOrderInvoiced_1.getTotalOrderInvoiced)(order);
};
exports.getTotalVariantBalance = getTotalVariantBalance;
